// extracted by mini-css-extract-plugin
export default {"imgBox":"Character_imgBox__V0fXQ"};